// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0d396e',
            light: '#3d5d8f',
            dark: '#092955',
            contrastText: '#fff',
        },
        secondary: {
            main: '#00cc98', // Beispiel: Orange
        },
        background: {
            default: '#f7f9fc',
            paper: '#ffffff',
        },
    },
    typography: {
        h1: {
            fontSize: "2.5rem",
            fontWeight: 700,
            color: "#f29216",
            textAlign: "center",
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        },
        h2: { fontWeight: 700, letterSpacing: '-0.01em' },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: { boxShadow: '0 8px 24px rgba(2,14,41,.06)' },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: { boxShadow: '0 6px 18px rgba(2,14,41,.08)' },
            },
        },
    },
});

export default theme;